module.exports = __webpack_public_path__ + "img/more-detail.3921f4aa.svg";